// auto-generated by Typewriter template _models.tst from PortCall.Models\Utils\Measurement.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';


// MeasurementData is the class that Measurement serializes to/from
export interface MeasurementData {
	
	
    Num : number;
    UOM : string;
}

// MeasurementOptions is the class which may be passed to the Measurement constructor to define optional initial data values
export interface MeasurementOptions {
	
	
    Num? : number;
    UOM? : string;
}

export class Measurement {
	
	
    public Num : DataSignal<number>;
    public UOM : DataSignal<string>;

    constructor();
    constructor(data : MeasurementOptions);
    constructor(data: MeasurementOptions | null = null) {
	    
	    
        this.Num = jsonableObservable(S.value<number>(data && data.Num !== undefined ? data.Num : 0));
        this.UOM = jsonableObservable(S.value<string>(data && data.UOM !== undefined ? data.UOM : ''));
    }

    static key(obj : Measurement) {
        return ;
    }
    
    static dataKey(obj : MeasurementOptions) {
        return ;
    }

    static update(obj : Measurement, data : MeasurementOptions) {
        S.freeze(() => {
	        
	        
            if (data.Num !== undefined) obj.Num(data.Num);
            if (data.UOM !== undefined) obj.UOM(data.UOM);
        });
    }
}

// NullableMeasurementData is the class that NullableMeasurement serializes to/from
export interface NullableMeasurementData {
	
	
    Num : number | null;
    UOM : string | null;
}

// NullableMeasurementOptions is the class which may be passed to the NullableMeasurement constructor to define optional initial data values
export interface NullableMeasurementOptions {
	
	
    Num? : number | null;
    UOM? : string | null;
}

export class NullableMeasurement {
	
	
    public Num : DataSignal<number | null>;
    public UOM : DataSignal<string | null>;

    constructor();
    constructor(data : NullableMeasurementOptions);
    constructor(data: NullableMeasurementOptions | null = null) {
	    
	    
        this.Num = jsonableObservable(S.value<number | null>(data && data.Num !== undefined ? data.Num : null));
        this.UOM = jsonableObservable(S.value<string | null>(data && data.UOM !== undefined ? data.UOM : null));
    }

    static key(obj : NullableMeasurement) {
        return ;
    }
    
    static dataKey(obj : NullableMeasurementOptions) {
        return ;
    }

    static update(obj : NullableMeasurement, data : NullableMeasurementOptions) {
        S.freeze(() => {
	        
	        
            if (data.Num !== undefined) obj.Num(data.Num);
            if (data.UOM !== undefined) obj.UOM(data.UOM);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/Measurement.ts